module.exports = __webpack_public_path__ + "img/match_loading.78293379.gif";